import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { FiCheckCircle, FiArrowRight, FiCalendar, FiAlertCircle } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { findIndustry, industries } from '../data/industries';
import './IndustryDetailPage.css';

const IndustryDetailPage = () => {
  const { slug } = useParams();
  const industry = findIndustry(slug);
  if (!industry) return <Navigate to="/industries" replace />;
  const Icon = industry.icon;
  const others = industries.filter((i) => i.slug !== slug);

  return (
    <>
      <SeoHead
        title={`${industry.title.replace(/&amp;/g, '&')} — Software, Marketing &amp; SEO`}
        description={industry.description.replace(/<[^>]+>/g, '')}
        path={`/industries/${slug}`}
      />

      <header
        className="industry-hero"
        style={{ '--ind-accent': industry.accent }}
      >
        <div className="container industry-hero-grid">
          <div>
            <span className="section-eyebrow">Industry</span>
            <div className="industry-hero-head">
              <div className="industry-hero-icon"><Icon /></div>
              <h1 dangerouslySetInnerHTML={{ __html: industry.title }} />
            </div>
            <p className="industry-hero-lead">{industry.description}</p>
            <div className="industry-hero-actions">
              <Link to="/schedule" className="btn btn-accent">
                <FiCalendar /> Schedule a consult
              </Link>
              <Link to="/contact" className="btn btn-ghost">
                Talk to us <FiArrowRight />
              </Link>
            </div>
          </div>
          <div className="industry-hero-pain">
            <FiAlertCircle />
            <div>
              <strong>Common pain</strong>
              <span>{industry.pain}</span>
            </div>
          </div>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">What we ship</span>
            <h2 className="section-title section-title--center">Outcomes, not features.</h2>
          </div>
          <div className="industry-outcomes">
            {industry.outcomes.map((o) => (
              <div key={o} className="industry-outcome card">
                <FiCheckCircle />
                <span dangerouslySetInnerHTML={{ __html: o }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-header">
            <span className="section-eyebrow">Other industries</span>
            <h2 className="section-title section-title--center">Explore where else we ship.</h2>
          </div>
          <div className="industries-grid">
            {others.map((i) => {
              const I = i.icon;
              return (
                <Link
                  key={i.slug}
                  to={`/industries/${i.slug}`}
                  className="industry-card"
                  style={{ '--ind-accent': i.accent }}
                >
                  <div className="industry-icon"><I /></div>
                  <h3 dangerouslySetInnerHTML={{ __html: i.title }} />
                  <p>{i.short}</p>
                  <span className="industry-link">
                    Read more <FiArrowRight />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustryDetailPage;
